var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.16 10.859c-.655-.61-1.602-.7-2.457-.7q-.19 0-.375-.028a2.273 2.273 0 0 1-2.215-2.366V7.62a2.275 2.275 0 0 1 2.269-2.268h1.013c.227 0 .458.021.69-.042A2.62 2.62 0 0 0 12 2.785 2.624 2.624 0 0 0 9.377.166c-1.45 0-2.466 1.15-2.619 2.52-.08.72-.413 1.414-.966 1.887-.272.232-.59.406-.933.505-.427.123-.947.1-1.387.1a2.62 2.62 0 1 0-.002 5.24c.788 0 1.515.012 2.181.491.438.315.753.764.934 1.27.183.509.154 1.056.352 1.558a2.65 2.65 0 0 0 2.44 1.662 2.62 2.62 0 0 0 1.782-4.54z"
  })));
};
export default SvgShare;